module.exports = __webpack_public_path__ + "img/5@3x.0e4149b3.png";